import log from "loglevel";
import update from "immutability-helper";
import { Map } from "immutable";
import { isType, Action } from "typescript-fsa";

import { demographicsGetSuccess } from "@sales/actions";
import {
    LocalisationInternalState as State,
    Country,
    Region,
    LocalisationNormalisedEntities,
} from "../models";
import { Localisation } from "../index";
import * as actions from "../actions";

// Intialise state to the browser language.
const getInitialState = (lang?: string) => ({
    language: lang == null ? Localisation.getBrowserLanguage() : lang,
    entities: {
        countries: Map<string, Country>(),
        regions: Map<string, Region>(),
    },
} as State);

function localisation(state: State = getInitialState(), action: actions.LocalisationAction): State {
    // State should never be null...
    if (state === null) {
        log.warn("localisation state setting to null, resetting to initialState.");
        state = {} as State;
        state = update(state, { $set: getInitialState() });
    }

    if (isType(action, actions.languageChange)) {
        // Locale Change
        return languageChange(state, action);
    }
    else if (isType(action, actions.countriesIndexSuccess)) {
        // Successful chartsIndex
        return mergeEntities(state, action.payload.entities);
    }
    else if (isType(action, demographicsGetSuccess)) {
        // Successful demographicsGet
        return mergeEntities(state, action.payload.models);
    }
    // Otherwise we do nothing
    return state;
}

function languageChange(state: State, action: Action<string>): State {
    // Update the language
    const newState = {
        language: action.payload,
    } as State;
    return update(state, { $merge: newState });
}

function mergeEntities(state: State, entities: LocalisationNormalisedEntities): State {
    // Set up the new state
    const newState = {
        entities: update(state.entities, {}),
    } as State;

    // Merge each map.
    newState.entities = state.entities;
    const { countries, regions } = entities;
    if (countries != null) {
        newState.entities = update(newState.entities, {
            countries: { $merge: state.entities.countries.merge(countries) },
        });
    }
    if (regions != null) {
        newState.entities = update(newState.entities, {
            regions: { $merge: state.entities.regions.merge(regions) },
        });
    }

    return update(state, {
        entities: { $merge: newState.entities },
    });
}

export { localisation, getInitialState };
